import {
    getBankAccount,
    listBankAccounts
} from './queries';
import {
    createBankAccount,
    deleteBankAccount,
    updateBankAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    BankAccount,
    CreateBankAccount,
    DeleteBankAccount,
    GetBankAccount,
    ListBankAccounts,
    UpdateBankAccount
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (customerId: string, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListBankAccounts>>(
        {
            query: listBankAccounts,
            variables: {
                filter: {
                    customerId: customerId
                },
                limit,
                nextToken,
            },
        });
    return response.data?.listBankAccounts;
};

export const fetch = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBankAccount>>(
        {
            query: getBankAccount,
            variables: {
                customerId: customerId,
                id: id
            },
        });
    return response.data?.getBankAccount;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateBankAccount>>(
        {
            query: createBankAccount,
            variables: {
                input: payload
            },
        });

    return response.data?.createBankAccount;
};

/**
 * FNP-918: the update payload is WHITELISTED to the API's Input type (§6).
 *
 * ⚠️ This previously read `delete record.created; delete record.updated;` and
 * sent the record itself. Two separate defects in three lines:
 *
 *  1. `delete` MUTATES THE CALLER'S OBJECT. The record handed in is the live
 *     Formik value or a React Query cache entry, so saving an account silently
 *     stripped `created`/`updated` from the copy the table was still rendering.
 *     `applications` shipped exactly this for months (FNP-996).
 *  2. Blacklisting is open-ended. Any field the API does not accept — anything
 *     added to the type later — rides along and the mutation fails on a field
 *     nobody chose to send.
 *
 * ⚠️ `accountNumber` is NOT in the whitelist. It is on the BankAccount type but
 * no query selects it, so a loaded record never carries it; including it would
 * send `undefined` for every edit, and worse, would invite a future caller to
 * populate it. Changing an account number is closing one account and opening
 * another — not an edit (§11).
 */
export const update = async (record: BankAccount) => {

    const input: Record<string, unknown> = {
        id: record.id,
        customerId: record.customerId,
        accountHolderName: record.accountHolderName,
        accountHolderType: record.accountHolderType,
    };

    Object.keys(input)
          .forEach(key => {
              if (typeof input[key] === 'undefined') {
                  delete input[key];
              }
          });

    const response = await client.graphql<GraphQLQuery<UpdateBankAccount>>(
        {
            query: (updateBankAccount),
            variables: {input},
        });
    return response.data?.updateBankAccount;
};

export const deleteRecord = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteBankAccount>>(
        {
            query: (deleteBankAccount),
            variables: {
                input: {
                    customerId: customerId,
                    id: id
                }
            },

        });
    return response.data?.deleteBankAccount;
};
